(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelectorAll('[data-collection-sort]').forEach((form) => {
    const select = form.querySelector('[data-sort-select]');
    const params = new URLSearchParams(window.location.search);

    if (!params.has('sort_by')) {
      params.set('sort_by', form.dataset.defaultSort || 'created-descending');
      window.location.replace(`${window.location.pathname}?${params.toString()}`);
      return;
    }

    if (select) {
      select.addEventListener('change', () => form.submit());
    }
  });

  } catch(e) { console.error(e); }
})();
})();
